<template>
  <div class="progressDataDebug">
    <h2>EDIT PROGRESS DATA</h2>
    <p>
      To edit progress data simply enter (and set) the activityId of the one you want to take.
      Please note, for now, you cannot move backwards in the curriculum.
    </p>
    <div class="debuginput">
      <label>
        ASN:
        <input name="asn" type="number" min="0" step="1" v-model="asn" number />
      </label>

      <button
        id="updateProgress"
        class="submitrewrite"
        @click.prevent="updateProgress"
        :disabled="isLoading"
      >
        Update Progress
      </button>

      <span :class="['updateResult', updateProgressResult]">{{ updateMessage }}</span>
    </div>

    <div class="debuginput">
      <button @click.prevent="showSpotCheckList" :disabled="isLoading">
        List Spot Checks
      </button>
      <span class="spotCheckList">{{ spotCheckAsns }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { isEmpty } from 'lodash';
import KeyboardingAPI from '../../api';

export default {
  data() {
    return {
      spotCheckAsns: '',
      asn: 0,
      isLoading: false,
      updateProgressResult: {
        hasSuccess: false,
        hasError: false
      },
      updateMessage: ''
    };
  },

  computed: {
    ...mapState('student', {
      studentId: state => state.id,
      curriculum: state => state.curriculum
    }),
    ...mapState('activity', {
      activityType: state => state.data.type
    })
  },
  methods: {
    ...mapActions('student', ['getCurriculum']),

    async updateProgress() {
      this.isLoading = true;
      if (isEmpty(this.curriculum)) await this.getCurriculum();

      // complete the previous activity so that we jump to the one we want
      const { activityId } = this.curriculum.find(activity => activity.asn === this.asn - 1) || {};

      if (!activityId) {
        this.isLoading = false;
        this.updateProgressResult = {
          hasSuccess: false,
          hasError: true
        };
        this.updateMessage = 'No such ASN';
        return;
      }
      const { status, data } = await KeyboardingAPI.addProgressData(
        this.activityType,
        this.studentId,
        {
          activityId,
          elapsedTime: 0,
          numberOfChars: 0,
          numberOfNonLetters: 0,
          errorData: [],
          complete: true
        }
      );

      this.isLoading = false;

      if (status < 400) {
        this.updateProgressResult = {
          hasSuccess: true,
          hasError: false
        };
        this.updateMessage = 'Success!';
      } else {
        this.updateProgressResult = {
          hasSuccess: false,
          hasError: true
        };
        this.updateMessage = 'Failed!';
      }
    },

    async showSpotCheckList() {
      this.isLoading = true;
      if (isEmpty(this.curriculum)) await this.getCurriculum();
      const spotCheckAsns = this.curriculum
        .filter(activity => activity.spotCheck)
        .map(({ asn }) => asn);
      this.spotCheckAsns = spotCheckAsns.length ? spotCheckAsns : '';
      this.isLoading = false;
    }
  }
};
</script>
